---
title: Offline Fishing Apps
description: What to consider when using fishing apps around weak signal, saved maps, trip notes, and safety planning.
---

# Offline Fishing Apps

Fishing often happens where signal is weak. Plan for that before you go.

## Before heading out

- Save important notes.
- Know your route and access points.
- Carry backup navigation when needed.
- Tell someone where you are going.
- Do not rely on one app for emergency decisions.

Roddo can support planning and logging, but your safety plan should not depend on a single device or service.
